import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {CqdbEquipmentDto} from '../../../types'

const QueryKey = 'get-cqdb-equipments'
export const useGetCqdbEquipments = (
  plantId: string,
  queryRange: {startDate?: Iso8601; endDate?: Iso8601}
) => {
  return useQuery<CqdbEquipmentDto[], AxiosError>({
    queryKey: [QueryKey, plantId, queryRange.startDate, queryRange.endDate],
    queryFn: async () => {
      const path = `/kpi-result/${plantId}/material-quality/cqdb-equipments`
      const response = await ApiClient.axiosInstance.get<CqdbEquipmentDto[]>(path, {
        params: {
          from: queryRange.startDate,
          to: queryRange.endDate
        }
      })

      return response.data
    }
  })
}
